import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FicheChantierInfosComponent } from '../fiche-chantier-infos/fiche-chantier-infos.component';

// interfaces
import { dataTableFicheChantier } from '../interfaces/DataTableFicheChantier';

// services
import { FicheChantierService } from '../services/fiche-chantier.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../services/auth.service';
import { FicheChantier } from '../interfaces/FicheChantier';

@Component({
    selector: 'app-fiche-chantier',
    templateUrl: './fiche-chantier.component.html',
    styleUrls: ['./fiche-chantier.component.scss'],
})
export class FicheChantierComponent implements OnInit {

    @BlockUI() blockUI: NgBlockUI;
    @ViewChild(DatatableComponent, { static: false }) table: DatatableComponent;

    ColumnMode = ColumnMode;
    columns = [
        { prop: 'display_name', name: 'Nom Chantier <i class="fa fa-sort sort-icon"></i></span>' },
        { prop: 'country', name: 'Pays <i class="fa fa-sort sort-icon"></i></span>' },
        { prop: 'street', name: 'Adresse <i class="fa fa-sort sort-icon"></i></span>' },
        { prop: 'cp_city', name: 'CP Ville <i class="fa fa-sort sort-icon"></i></span>' },
        { prop: 'btn_show', name: 'Voir les informations' },
    ];

    ficheChantier: Array<FicheChantier>;
    dataTableFicheChantier: Array<dataTableFicheChantier>;
    currentPage: number = 1;
    collectionSize: number;
    totalItems: number = 10;
    searchField: string = "";
    columnSearch: string = "name";
    start: number = 0;

    network;
    onTwoNetworks: boolean = false;
    selectedNetwork: string = 'MDM';
    role: string;
    id_org_internal: string;

    empty_msgFr = {
        'emptyMessage': ''
    };

    constructor(
        private ficheChantierService: FicheChantierService,
        private toastrService: ToastrService,
        private orderModalService: NgbModal,
        private translate: TranslateService,
        private authService: AuthService,
    ) {
        translate.get('Aucune donnée disponible', { value: '' })
            .subscribe((res: string) => this.empty_msgFr.emptyMessage = res);
    }

    ngOnInit() {
        this.getFicheChantiers();
    }

    ngAfterViewInit(): void {
        this.fixBrowserTooltip();
    }

    onPageChange(currentPage: number) {
        this.start = currentPage * this.totalItems - this.totalItems;
        this.getFicheChantiers();
    }

    showClientInfos(FicheChantier: FicheChantier) {
        const modalRef = this.orderModalService.open(FicheChantierInfosComponent);
        modalRef.componentInstance.ficheChantier = FicheChantier;
    }

    getFicheChantiers(): void {
        this.blockUI.start('Loading');

        const request = {
            network: this.selectedNetwork,
            nbByPage: this.totalItems,
            start: this.start,
            search: {
                [this.columnSearch]: this.searchField
            },
            token: localStorage.getItem('token')
        }

        this.ficheChantierService.getFicheChantier(request).subscribe(
            (res) => {
                if (res.success) {
                    this.ficheChantier = res.data.results;
                    this.collectionSize = res.data.count;
                    this.blockUI.stop();
                    this.dataTableFicheChantier = this.setDataTableClient();
                } else {
                    this.blockUI.stop();

                    if (res.errorSet.includes('INVALID_PARAMS')) {
                        this.toastrService.error('Les paramètres sont invalides');
                    } else if (res.errorSet.includes('ERROR_SERVER')) {
                        this.toastrService.error('Une erreur serveur est survenue');
                    } else {
                        this.toastrService.error('Une erreur s\'est produite');
                    }
                }
            },
            (error) => {
                this.blockUI.stop();
                this.toastrService.error('Une erreur s\'est produite');
            }
        );
    }

    setDataTableClient(): Array<dataTableFicheChantier> {
        let dataTable = JSON.parse(JSON.stringify(this.ficheChantier));
        return dataTable
    }

    fixBrowserTooltip(): void {
        let headerTitle = document.querySelectorAll('.datatable-header-cell');

        headerTitle.forEach(element => {

            let title = element.getAttribute('title');
            element.setAttribute('title', title.replace('<i class="fa fa-sort sort-icon"></i></span>', ''));

        });

    }

    onSearchChange(value: any) {
        this.getFicheChantiers();
    }

    resetSearch() {
        if (this.searchField) {
            this.searchField = "";
            this.getFicheChantiers();
        }
    }
}
